

(function() {
  'use strict';
  
  const FAQLanding = {
    init: function(sectionId) {
      this.section = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!this.section) return;
      
      this.topLevelView = this.section.querySelector('[data-view="top-level"]');
      this.subcategoriesView = this.section.querySelector('[data-view="subcategories"]');
      this.subcategoriesTitle = this.section.querySelector('.faq-subcategories-title');
      
      this.bindEvents();
    },
    
    bindEvents: function() {
      // Handle top-level category clicks
      const topLevelCards = this.section.querySelectorAll('[data-action="show-subcategories"]');
      
      topLevelCards.forEach(card => {
        card.addEventListener('click', (e) => {
          e.preventDefault();
          const categoryId = card.dataset.categoryId;
          const categoryName = card.dataset.categoryName || card.querySelector('.faq-category-name').textContent;
          this.showSubcategories(categoryId, categoryName);
        });
      });
      
      // Handle back buttons
      const backButtons = this.section.querySelectorAll('[data-action="back-to-top-level"]');
      backButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.showTopLevel();
        });
      });
    },
    
    showSubcategories: function(parentId, parentName) {
      // Update title
      this.subcategoriesTitle.textContent = parentName;
      
      // Get all subcategories for this parent
      const allSubcategories = this.section.querySelectorAll('.faq-subcategory-card');
      const backCard = this.section.querySelector('.faq-back-card');
      
      // Hide all subcategories first
      allSubcategories.forEach(card => {
        card.style.display = 'none';
        card.style.animationDelay = '0s';
      });
      
      // Show only subcategories that match this parent
      let visibleCount = 0;
      allSubcategories.forEach((card) => {
        const parentIds = card.dataset.parentIds || '';
        const parentIdArray = parentIds.split(',').map(id => id.trim());
        
        // Check if the clicked parent ID is in this subcategory's parent list
        if (parentIdArray.includes(parentId)) {
          card.style.display = 'block';
          card.style.animationDelay = `${visibleCount * 0.05}s`;
          visibleCount++;
        }
      });
      
      // Show back card with delay
      if (backCard) {
        backCard.style.display = 'block';
        backCard.style.animationDelay = `${visibleCount * 0.05}s`;
      }
      
      // Perform slide transition
      this.slideToView(this.subcategoriesView);
    },
    
    showTopLevel: function() {
      this.slideToView(this.topLevelView);
    },
    
    slideToView: function(targetView) {
      const currentView = this.section.querySelector('.faq-view.active');
      
      if (currentView === targetView) return;
      
      // Remove active class and add slide-out
      currentView.classList.remove('active');
      currentView.classList.add('slide-out-left');
      
      // Add active class to target view
      targetView.classList.add('active', 'slide-in-right');
      
      // Clean up animation classes after transition
      setTimeout(() => {
        currentView.classList.remove('slide-out-left');
        targetView.classList.remove('slide-in-right');
      }, 400);
    }
  };
  
  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    const faqSection = document.querySelector('[data-section-type="faq-landing"]');
    if (faqSection) {
      const sectionId = faqSection.dataset.sectionId;
      FAQLanding.init(sectionId);
    }
  });
  
  // Re-initialize on Shopify theme editor section load
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.target.querySelector('[data-section-type="faq-landing"]');
      if (section) {
        const sectionId = section.dataset.sectionId;
        FAQLanding.init(sectionId);
      }
    });
  }
})();
